import api from './api';

const spinGameService = {
  getSettings: async () => {
    const response = await api.get('/spin-game/settings');
    return response.data;
  },
  saveSettings: async (settings) => {
    const response = await api.put('/spin-game/settings', settings);
    return response.data;
  },
  play: async () => {
    const response = await api.post('/spin-game/play');
    return response.data;
  },
  getMyTransactions: async () => {
    const response = await api.get('/spin-game/my-transactions');
    return response.data;
  },
  getAllTransactions: async () => {
    const response = await api.get('/spin-game/transactions');
    return response.data;
  },
};

export default spinGameService;
